import React from 'react';
import { BaseAppProviderProps } from '../web-component-wrapper/types';

export interface ComponentWrapperProps<T extends BaseAppProviderProps> {
  children: React.ReactNode;
  appProvider: (props: T) => JSX.Element;
}

export const ComponentWrapper = (props: any) => {
  return <props.appProvider {...props}>{props.children}</props.appProvider>;
};
